import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CenSpcIsShippingFieldCompletedState from "@tCentro/Store/Reducer/CenSpcIsShippingFieldCompletedState";
import { Draft } from "immer";

const initialState: CenSpcIsShippingFieldCompletedState = {
    isShippingFieldCompletedValue:false,
};

const reducer = {
    "Pages/OnePageCheckout/CenSpcShippingFieldCompleted": (draft: Draft<CenSpcIsShippingFieldCompletedState> ,
         action: {
            isShippingFieldCompletedValue: boolean;
    },) => {
   
        draft.isShippingFieldCompletedValue = action.isShippingFieldCompletedValue;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);